import { useState, type ReactNode } from "react";

import { Button } from "@/components/ui/button";

/** Every table and list on the item page shows its first 10 rows until "Show all" (Ioan 2026-10-09). */
export const ITEM_TOP_N = 10;
export const SHOW_ALL = "Show all";
export const SHOW_TOP = "Show top 10";

export function topRows<T>(rows: T[], open: boolean): T[] {
  return open ? rows : rows.slice(0, ITEM_TOP_N);
}

export function TopNToggle({ total, open, onToggle }: { total: number; open: boolean; onToggle: () => void }) {
  if (total <= ITEM_TOP_N) return null;
  return (
    <div className="mt-2">
      <Button data-nonmutating type="button" variant="outline" size="sm" aria-expanded={open} onClick={onToggle}>
        {open ? SHOW_TOP : `${SHOW_ALL} (${total})`}
      </Button>
    </div>
  );
}

/** Renders the first 10 rows, and the toggle under them when there are more. */
export function TopN<T>({ rows, children }: { rows: T[]; children: (shown: T[]) => ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {children(topRows(rows, open))}
      <TopNToggle total={rows.length} open={open} onToggle={() => setOpen(!open)} />
    </>
  );
}
